"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const react_1 = __importDefault(require("react"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const merge_1 = __importDefault(require("lodash/merge"));
const styled_components_1 = require("styled-components");
const monera_app_core_1 = require("@amzn/monera-app-core");
const monera_app_core_2 = require("@amzn/monera-app-core");
const monera_app_core_3 = require("@amzn/monera-app-core");
const ThemeProvider = (props) => {
    const { children, theme } = props;
    const [shoppingPortalState] = (0, monera_app_core_2.useShoppingPortalStore)();
    const deviceType = shoppingPortalState.deviceType;
    const baseTheme = deviceType === monera_app_core_1.DeviceType.Mobile || deviceType === monera_app_core_1.DeviceType.MShop ? monera_app_core_3.moneraMobileTheme : monera_app_core_3.moneraTheme;
    const mergedTheme = (0, merge_1.default)((0, cloneDeep_1.default)(baseTheme), theme);
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: mergedTheme }, children);
};
exports.ThemeProvider = ThemeProvider;
__exportStar(require("./types"), exports);
